<div class="webphone-wrapper">
  <!-- <ng-container *ngIf="callState$ | async as callState"> -->
    <!-- Incoming Call -->
    <etelecom-cs-incoming-call (playAudioUrl)="onPlayAudioUrl($event)" *ngIf="(callState$ | async) === CallingState.callingIn">
    </etelecom-cs-incoming-call>

    <!-- Active Call (Processing or Holding) -->
    <etelecom-cs-active-call
      *ngIf="(callState$ | async) === CallingState.callProcessing || (callState$ | async) === CallingState.callHolding">
    </etelecom-cs-active-call>

    <etelecom-cs-call-outgoing 
      *ngIf="(callState$ | async) === CallingState.callingOut">
    </etelecom-cs-call-outgoing>

    <!-- Outgoing Call or Idle - Show Dialer -->
    <etelecom-cs-webphone-dialer 
      *ngIf="(callState$ | async) === CallingState.none">
    </etelecom-cs-webphone-dialer>
  <!-- </ng-container> -->
   <div class="video-container" *ngIf="isVideoCall$ | async">
    <video #remoteVideo autoplay class="remote-video">
    </video>
    <video #localVideo autoplay muted class="local-video">
    </video>
  </div>

<div class="audio-container">
  <audio #remoteAudio id="remoteAudio" autoplay>
  </audio>
  <audio style="display: none" #localAudio loop type="audio/mpeg"></audio>
</div>
</div>

